// @flow

import React from 'react';
import ListPage from 'esm-web-pro/containers/pages/ListPage';
import { FormattedMessage } from 'react-intl';
import ActionsColumn from 'speed-js-react-web/src/components/grommet2/tables/columns/Action/ActionsColumn';
import DocumentsSidePanel from 'esm-web-pro/containers/pages/projects/document/sidepanel/DocumentsSidePanel';
import QuickViewIcon from 'esm-web-pro/components/icons/QuickViewIcon';
import withRouter from 'speed-js-react/src/router/withRouter';

const DOCUMENT_SIDEPANEL_KEY = 'DOCUMENT_SIDEPANEL_KEY';

type Props = {
    project: Object,
    match: Object,
};

const DocumentsPage = (props: Props) => {
    const listRef = React.useRef(null);

    const reloadData = () => {
        if (listRef.current && listRef.current.table.current) {
            listRef.current.table.current.reloadData();
        }
    };

    const { project } = props;
    return (
        <ListPage
            ref={listRef}
            {...props}
            resourceName="projectDocumentNested"
            permissions={['documents.view_document']}
            createButtonPermissions={['documents.add_document']}
            resourceArguments={[project.uuid]}
            columns={[
                {
                    Header: <FormattedMessage
                        id="name"
                        defaultMessage="Name"
                    />,
                    accessor: 'name_display',
                    minWidth: 120,
                },
                {
                    Header: <FormattedMessage id="stage" defaultMessage="Stage" />,
                    accessor: 'stages',
                    Cell: (rowProps) => rowProps.original.stages?.map((type) => type.name).join(', '),
                    minWidth: 120,
                },
                {
                    Header: '',
                    actions: [
                        {
                            label: <FormattedMessage
                                id="projmanag-counterparties-quickview"
                                defaultMessage="Quick View"
                            />,
                            type: 'quickView',
                            accessor: 'uuid',
                            resourceArguments: [project.uuid],
                            component: DocumentsSidePanel,
                            resourceName: 'projectDocumentNested',
                            icon: <QuickViewIcon />,
                            to: '/{id}/quick_view',
                            getTitle: (obj) => obj.name_display,
                            panelId: DOCUMENT_SIDEPANEL_KEY,
                            reload: reloadData,
                        },
                    ],
                    Cell: ActionsColumn,
                    minWidth: 70,
                },
            ]}
            newObjectLabel={(
                <FormattedMessage
                    id="project-document-new"
                    defaultMessage="New Document"
                />
            )}
            editObjectLabel={(
                <FormattedMessage
                    id="project-edit-document"
                    defaultMessage="Edit Document"
                />
            )}
        />
    );
};

export default withRouter(DocumentsPage);
